/**
 * TURN CC · 22 → CC · 24 (perf refresh).
 *
 * Kanban pipeline hook — same instant-hydration pattern as
 * useCalendarEvents.
 *
 * Cache strategy:
 *  - staleTime 30s     : the pipeline can move (a brief flips to
 *                        `sent`) so we accept a slightly shorter stale.
 *  - gcTime 24h        : survives reload (matches persister maxAge).
 *  - placeholderData   : keepPreviousData → smooth reloads.
 *  - refetchOnMount=false / refetchOnWindowFocus=false.
 *  - refetchInterval 60s in background — cheap read endpoint.
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { API, authHeaders, apiJson } from "@/lib/api";

export function kanbanPipelineQueryFn({ days }) {
  return apiJson(`${API}/kanban/pipeline?days=${days}`, {
    headers: authHeaders(),
  });
}

export function kanbanPipelineQueryKey({ days = 7 } = {}) {
  return ["kanban", "pipeline", days];
}

export function useKanbanPipeline({ days = 7 } = {}) {
  return useQuery({
    queryKey: kanbanPipelineQueryKey({ days }),
    queryFn: () => kanbanPipelineQueryFn({ days }),
    staleTime: 30_000,
    gcTime: 24 * 60 * 60_000,
    placeholderData: keepPreviousData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: 60_000,
  });
}
